export default {
  text: {
    order_cancelled: 'Encomenda cancelada - Estafeta indisponível',
    wolt_support: 'Dúvidas? Contacte o Wolt diretamente <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENTE:</strong> Aceite ou rejeite esta encomenda imediatamente',
    no_driver_found: '<strong>Nenhum estafeta encontrado.</strong> Entregue esta encomenda você mesmo ou cancele-a',
  },
  labels: {
    dummy_order: 'Encomenda de teste',
    items_one: '{{count}} artigo',
    items_other: '{{count}} artigos',
    needs_acceptance: 'Aguarda aceitação',
    driver_pending: 'À espera de estafeta',
    driver_search_retrying: 'A procurar estafeta',
    no_driver_found: 'Nenhum estafeta encontrado',
    today: 'Hoje',
    driver_assigned: 'Estafeta atribuído',
    complete: 'Concluída',
  },
  buttons: {
    complete_order: 'Marcar como concluída',
    looking_for_driver: 'À procura de estafeta...',
    click_to_remove: 'Clique para remover',
  },
};
